import { Bar, BarChart, ResponsiveContainer, XAxis } from 'recharts';
import * as S from './ReportChart.style';
import CustomLabel from './CustomLabel';
import { SALES_REPORT_ALL_BAR_DATA, SALES_REPORT_SILOVE_BAR_DATA, SALES_REPORT_SINOR_BAR_DATA } from './ReportChart.attribute';

const RADIUS = 8;

export default function ReportChart({ category, barName, compareDate, current, previous, variant }) {
    if (!barName) return null;
    const { prevName, currName } = barName;
    const barData = category === 'all' ? SALES_REPORT_ALL_BAR_DATA : category === 'sinor' ? SALES_REPORT_SINOR_BAR_DATA : SALES_REPORT_SILOVE_BAR_DATA;

    const data = [
        { name: prevName, ...previous.sales[variant], refunds: previous.refunds[variant], point: previous.sales.point.total, dataVariant: 'previous' },
        { name: currName, ...current.sales[variant], refunds: current.refunds[variant], point: current.sales.point.total, dataVariant: 'current' },
    ];

    const renderTick = ({ x, y, payload }) => {
        const WIDTH = 200;
        const centerX = x - WIDTH / 2;
        const date = !!compareDate && payload.value === prevName ? compareDate?.prev : compareDate?.curr;
        return (
            <foreignObject x={centerX} y={y} width={WIDTH} height={!!compareDate ? 48 : 24}>
                <S.TickContainer style={{ width: WIDTH + 'px', height: !!compareDate ? '48px' : '24px' }}>
                    <span>{payload.value}</span>
                    {!!compareDate ? <span>{date}</span> : null}
                </S.TickContainer>
            </foreignObject>
        );
    };

    const CustomBarShape = (props) => {
        const { x, y, width, height, payload, fill, dataKey } = props;
        const opacity = payload.dataVariant === 'previous' ? 0.5 : 1;

        const topKey = [...barData].reverse().find((b) => (payload?.[b.dataKey] ?? 0) > 0)?.dataKey;
        const isTop = dataKey === topKey;
        if (isTop) {
            return (
                <path
                    d={`M${x},${y + height} 
                L${x},${y + RADIUS} 
                Q${x},${y} ${x + RADIUS},${y} 
                L${x + width - RADIUS},${y} 
                Q${x + width},${y} ${x + width},${y + RADIUS} 
                L${x + width},${y + height} 
                Z`}
                    fill={fill}
                    opacity={opacity}
                />
            );
        }
        return <rect x={x} y={y} width={width} height={height} fill={fill} opacity={opacity} />;
    };

    return (
        <div>
            <CustomLabel previousTotal={previous.sales[variant].total} currentTotal={current.sales[variant].total} />
            <ResponsiveContainer height={151} width="100%">
                <BarChart accessibilityLayer barCategoryGap="10%" barGap={4} data={data} id="z-Stacked" stackOffset="none" syncMethod="index">
                    <XAxis dataKey="name" strokeDasharray="3 3" type="category" tickLine={false} tick={renderTick} height={!!compareDate ? 48 : 24} />
                    {barData.map((bar) => (
                        <Bar key={bar.dataKey} barGap={30} barSize="100%" dataKey={bar.dataKey} fill={bar.fill} stackId={'a'} shape={CustomBarShape} />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
